import React from 'react'

import PropTypes from 'prop-types'

import './steps2.css'

const Steps2 = (props) => {
  return (
    <div id="O mně" className="steps2-container thq-section-padding">
      <div className="steps2-max-width thq-section-max-width">
        <div className="steps2-container1 thq-grid-2">
          <div className="steps2-section-header">
            <h2 className="thq-heading-2">O mně a numeroskopech</h2>
            <p className="thq-body-large">
              V Praze,  či na dálku. Sestavím vám váš numeroskop, který pomůže
              poodhalit výhledové tendence vašeho života.
            </p>
            <div className="steps2-actions">
              <button className="thq-button-filled thq-button-animated steps2-button">
                <span className="thq-body-small">Napište mi SMS</span>
              </button>
            </div>
          </div>
          <div className="steps2-container2">
            <div className="steps2-container3 thq-card">
              <h2 className="thq-heading-2">{props.step1Title}</h2>
              <span className="steps2-text04 thq-body-small">
                {props.step1Description}
              </span>
              <label className="steps2-text05 thq-heading-3">01</label>
            </div>
            <div className="steps2-container4 thq-card">
              <h2 className="thq-heading-2">{props.step2Title}</h2>
              <span className="steps2-text07 thq-body-small">
                {props.step2Description}
              </span>
              <label className="steps2-text08 thq-heading-3">02</label>
            </div>
            <div className="steps2-container5 thq-card">
              <h2 className="thq-heading-2">{props.step3Title}</h2>
              <span className="steps2-text10 thq-body-small">
                {props.step3Description}
              </span>
              <label className="steps2-text11 thq-heading-3">03</label>
            </div>
            <div className="steps2-container6 thq-card">
              <h2 className="thq-heading-2">{props.step4Title}</h2>
              <span className="steps2-text13 thq-body-small">
                {props.step4Description}
              </span>
              <label className="steps2-text14 thq-heading-3">04</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Steps2.defaultProps = {
  step1Title: 'Kdo jsem?',
  step4Description: 'Své služby poskytuji v Praze.',
  step3Title: 'Numeroskop - Co to znamená?',
  step1Description:
    'Jmenuji se Ivana Šulcová. Jsem certifikovaná absolventka pětiletého studia na škole AMEU (Akademie energetického účetnictví).',
  step4Title: 'Praha či online',
  step2Description:
    'Zabývám se tvorbou numeroskopů, tj. osobnostním výkladem dle Vašeho data narození.',
  step2Title: 'Osobnostní výklady',
  step3Description:
    'Jedná se o výklad charakteristiky člověka, aspekty jeho zdravotního stavu, partnerských a rodinných vztahů apod.',
}

Steps2.propTypes = {
  step1Title: PropTypes.string,
  step4Description: PropTypes.string,
  step3Title: PropTypes.string,
  step1Description: PropTypes.string,
  step4Title: PropTypes.string,
  step2Description: PropTypes.string,
  step2Title: PropTypes.string,
  step3Description: PropTypes.string,
}

export default Steps2
